<template lang="pug">
  div
    div(class="headline") Overview
    div(v-if="loading")
      div(style="display: flex; justify-content: center;")
        v-progress-circular(size="50" indeterminate)
    div(v-else class="subheading" style="display: flex;")
      div(style="flex: 1; padding: 20px;")
        div(style="display: flex;")
          div(style="flex: auto;") Total cost of maintenance
          div(style="flex: none;")
            span(class="grey--text") $
            span
              | {{ Number(total).
              |      toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
        div(style="display: flex;")
          div(style="flex: 1 1 70%;") Most expensive site
          div(style="flex: none;")
            v-tooltip(left)
              router-link(:to="{ name: 'site',\
                                 params: { id : mostExpensiveSite } }"
                          class="clickable"
                          slot="activator") {{ mostExpensiveSite }}
              span(class="grey--text") $
              span
                | {{ Number(mostExpensive).
                |    toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
        div(style="display: flex;")
          div(style="flex: auto;") Most visited site
          div(style="flex: none;")
            v-tooltip(left)
              router-link(:to="{ name: 'site',\
                                 params: { id : mostVisitedSite } }"
                          class="clickable"
                          slot="activator") {{ mostVisitedSite }}
              span {{ Number(mostVisited).toLocaleString() }}
              span(class="grey--text text--lighten-1") &nbsp;visits
      div(style="flex: none; margin: 10px 30px; border-left: 1px solid grey;")
      div(style="flex: 1; padding: 20px;")
        div(style="display: flex;")
          div(style="flex: auto;") Issues
          div(style="flex: none;")
            v-chip(v-if="issues.oua > 0" color="red accent-3" small)
              | {{ Number(issues.oua).toLocaleString() }}
            v-chip(v-if="issues.cua > 0" color="orange accent-3" small)
              | &nbsp;{{ Number(issues.cua).toLocaleString() }}
            v-chip(v-if="issues.oa > 0" color="yellow accent-3" small)
              | &nbsp;{{ Number(issues.oa).toLocaleString() }}
            v-chip(color="green accent-3" small)
              | &nbsp;{{ Number(issues.ca).toLocaleString() }}
        div(style="display: flex;")
          div(style="flex: auto;") Jobs
          div(style="flex: none;")
            v-chip(v-if="jobs.raised > 0" color="red accent-3" small)
              | {{ Number(jobs.raised).toLocaleString() }}
            v-chip(color="green accent-3" small)
              | &nbsp;{{ Number(jobs.completed).toLocaleString() }}

</template>

<script>
export default {
  name: "overview",
  data () {
    return {
      error: false,
      issues: {
        oua: 0,
        oa: 0,
        cua: 0,
        ca: 0
      },
      jobs: {
        completed: 0,
        raised: 0
      },
      loading: false,
      mostExpensive: 0,
      mostExpensiveSite: "N/A",
      mostVisited: 0,
      mostVisitedSite: "N/A",
      total: 0
    };
  },
  created () {
    this.loading = true;
    Promise.all([
      this.$http.get("/api/issues"),
      this.$http.get("/api/jobs"),
      this.$http.get("/api/reports/jobs"),
      this.$http.get("/api/reports/sites")
    ]).
      then(([issues, jobs, repJobs, repSites]) => {
        for (const issue of issues.data) {
          // eslint-disable-next-line no-negated-condition
          if (!issue.dateClosed) {
            if (issue.category.id) {
              this.issues.oa += 1;
            } else {
              this.issues.oua += 1;
            }
          } else {
            if (issue.category.id) {
              this.issues.ca += 1;
            } else {
              this.issues.cua += 1;
            }
          }
        }
        for (const job of jobs.data) {
          if (job.completed) {
            this.jobs.completed += 1;
          } else {
            this.jobs.raised += 1;
          }
        }
        for (const job of repJobs.data) {
          this.total += job.Cost;
        }
        for (const site of repSites.data) {
          if (site["Total cost of jobs"] > this.mostExpensive) {
            this.mostExpensive = site["Total cost of jobs"];
            this.mostExpensiveSite = site.Site;
          }
          if (site["Jobs count"] > this.mostVisited) {
            this.mostVisited = site["Jobs count"];
            this.mostVisitedSite = site.Site;
          }
        }
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Overview.vue